import { Component, OnInit, OnDestroy, ViewChild, EventEmitter } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import { ActivatedRoute } from '@angular/router';
import { Events } from '../../../utils/event-utils';
import { SocketService } from '../../../service/socket-service/socket-service.service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
declare var $;
@Component({
  selector: 'app-driver-alert',
  templateUrl: './driver-alert.component.html',
  styleUrls: ['./driver-alert.component.css']
})
export class DriverAlertComponent implements OnInit, OnDestroy {
  driverList = [];
  driverSms = [];
  endPoint = null;
  searchDriver: any;
  searchMessages: any;
  newMessage = null;
  user;
  selectedDriver;

  constructor(
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.getUser();

    this.endPoint = this.activatedRoute.snapshot.url[0].path;
    if (this.endPoint === 'driveralerts') {
      this.getDriverList();
    } else if (this.endPoint === 'queries') {
      this.getQueriesUserList();
    }

    this.setUpDriverAlertSocketListener();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
        }
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
          this.fetchSms(this.driverList[0])
        }
      });
  }

  getQueriesUserList() {
    this.driverService
      .getQueriesUserList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
          this.fetchSms(this.driverList[0])
        }
      });
  }

  fetchSms(userObj) {
    this.selectedDriver = userObj;
    if (this.endPoint === 'queries') {

      if (userObj._id) {

        const data = {
          driverObj: userObj,
          endPoint: this.endPoint
        };
        this.getDriverSms(data);
      }
      return;
    } else if (this.endPoint === 'driveralerts') {
      if (userObj._id) {
        // this.selectedUserId = userObj._id;
        const data = {
          id: userObj._id,
          endPoint: this.endPoint
        };
        this.getDriverSms(data);
      }
      return;
    }

  }

  getDriverSms(payload) {
    this.driverService
      .getDriversSms(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverSms = data;
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  getImage(userObj) {

    if (this.endPoint === 'queries') {
      if (userObj.driver) {
        if (userObj.driver.profileImageURL) {
          return userObj.driver.profileImageURL;
        }
        return '#';
      }
      return '#';
    } else if (this.endPoint === 'driveralerts') {
      if (userObj.profileImageURL) {
        return userObj.profileImageURL;
      }
      return '#';
    }
  }

  getDisplayName(userObj) {

    if (this.endPoint === 'queries') {
      if (userObj.driver) {
        if (userObj.driver.displayName) {
          return userObj.driver.displayName;
        }
        return '#';
      }
      return 'N/A';
    } else if (this.endPoint === 'driveralerts') {
      if (userObj.displayName) {
        return userObj.displayName;
      }
      return 'N/A';
    }
  }

  sendMessage() {
    const message = {
      title: '',
      message: this.newMessage,
      receiver: this.selectedDriver
    };
    this.socketService.emit(Events.DRIVER_ALERT_CALL, message);
    this.newMessage = null;
  }

  setUpDriverAlertSocketListener() {
    this.socketService.addListener(Events.DRIVER_ALERT_CALL)
    .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          this.driverSms.push(data.driverAlert);
        } else {
          sweetAlert('Error', data.message, 'error', 'OK');

        }
      });

    this.socketService.addListener(Events.RECEIVE_DRIVER_ALERT_MESSAGE_CALL)
    .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          this.driverSms.push(data.driverAlert);
        } else {
          sweetAlert('Error', data.message, 'error', 'OK');

        }
      });
  }

  ngOnDestroy(): void {
  }
}
